import React, { useEffect, useState } from "react";
import {
  Container,
  Typography,
  Toolbar,
  Box,
  AppBar,
  MenuItem,
  Menu,
} from "@mui/material";
import { Grid } from "@mui/material";
import LanguageSelect from "./TranslateDropdown";
import MoreIcon from "@mui/icons-material/MoreVert";
import IconButton from "@mui/material/IconButton";
import Link from "next/link";
import { useRouter } from "next/router";
import { getSurveyOpen } from "../../utils/router";
export const MapHeader: React.FC = () => {
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [width, setWidth] = useState(0);
  const [surveyOpen, setSurveyOpen] = useState<boolean>();
  const router = useRouter();
  useEffect(() => {
    if (router.isReady) setSurveyOpen(getSurveyOpen(router));
  }, [router.isReady]);
  useEffect(() => {
    if (typeof window !== "undefined") {
      setWidth(window.innerWidth);
    }
  }, []);

  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(undefined);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const renderMenu = (
    <Grid
      container
      spacing={2}
      sx={{
        alignContent: "left",
        justifyContent: "flex-start",
        alignItems: "center",
      }}
    >
      <Grid item sx={{}}>
        <LanguageSelect />
      </Grid>
      {/*<Grid item>
        <Survey surveyOpen={surveyOpen} />
    </Grid>*/}
    </Grid>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      id={mobileMenuId}
      disableRestoreFocus
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      open={isMobileMenuOpen || surveyOpen || false}
      onClose={handleMobileMenuClose}
    >
      {/*<MenuItem>{<Survey surveyOpen={surveyOpen} />}</MenuItem>*/}
      <MenuItem>{<LanguageSelect />}</MenuItem>
    </Menu>
  );

  return (
    <AppBar
      color="primary"
      sx={{
        backgroundColor: "#bf0000",
        width: "100vw",
        height: "fit-content",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Container sx={{ marginLeft: "16px", maxWidth: "940px" }}>
        <Toolbar
          disableGutters
          sx={{ justifyContent: "space-between", width: "85vw" }}
        >
          <Box display="flex" sx={{ alignItems: "center" }}>
            <Link href="/">
              <Typography
                variant="h6"
                component="div"
                sx={{
                  paddingRight: "12px",
                  lineHeight: "1.2rem",
                  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                }}
              >
                DME
              </Typography>
            </Link>
            <a href="/">
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontWeight: "400",
                  lineHeight: "1.2rem",
                  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.25rem" },
                }}
              >
                Interactive Boundary Explorer
              </Typography>
            </a>
          </Box>

          <Box sx={{ display: { xs: "flex", md: "inline" } }}>
            {width < 900 ? (
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            ) : null}

            {width < 900 ? renderMobileMenu : renderMenu}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
